import { MissingEntityError, trackError } from '#api/errors.ts';
import { useSuspenseGetMaxRolesQuery } from '#api/roles.queries.ts';

export class MissingRoleError extends MissingEntityError {
  constructor(roleId: string) {
    super(roleId);
    this.name = 'MissingRoleError';
  }
}

/**
 * Gets the name of a role.  Instead of fetching the individual role details, which can result in too
 * many requests on host list pages, we fetch all the roles, then find the role within that list to get its name.
 *
 * If the role is not found, we throw a custom error type that can be caught with an ErrorBoundary.
 */
export function useRoleName(roleId: string) {
  const allRoles = useSuspenseGetMaxRolesQuery().data.data;
  const role = allRoles.find((r) => r.id === roleId);

  if (!role) {
    const err = new MissingRoleError(roleId);
    trackError(err);
    throw err;
  }

  return role.name;
}
